import { Integration, IntegrationAction } from '../../../../../shared/interfaces/integration';
import { EntityAction } from '../../../../../entity-actions/interfaces/entity-actions';
import {
  PIPELINE_OVERVIEW_DISPLAY_CONFIG_DESTINATION_EDIT_ACTION,
  PIPELINE_OVERVIEW_DISPLAY_CONFIG_EDIT_ACTION,
  PIPELINE_OVERVIEW_DISPLAY_CONFIG_SOURCE_EDIT_ACTION
} from '../../../../PipelineActions/constants/pipeline-actions';
import { DestinationAction } from '../../../../../shared/interfaces/destination';
import { SourceAction } from '../../../../../shared/interfaces/source';

export function getPipelineOverviewActionsProps(integration: Integration) {
  const integrationActions: EntityAction<IntegrationAction>[] = getEntityActions<IntegrationAction>(
    integration.actions,
    IntegrationAction.EDIT,
    PIPELINE_OVERVIEW_DISPLAY_CONFIG_EDIT_ACTION
  );

  const destinationActions: EntityAction<DestinationAction>[] = getEntityActions<DestinationAction>(
    integration.destination!.actions,
    DestinationAction.EDIT,
    PIPELINE_OVERVIEW_DISPLAY_CONFIG_DESTINATION_EDIT_ACTION
  );

  const sourceActions: EntityAction<SourceAction>[] = getEntityActions<SourceAction>(
    integration.source!.actions,
    SourceAction.EDIT,
    PIPELINE_OVERVIEW_DISPLAY_CONFIG_SOURCE_EDIT_ACTION
  );

  return {
    integrationActions,
    destinationActions,
    sourceActions,
    integration
  };
}

function getEntityActions<A>(
  actions: EntityAction<A>[],
  editAction: A,
  actionOverride: EntityAction<A>
) {
  return actions
    .filter(action => action.action === editAction)
    .map(ea => ({
      ...ea,
      ...actionOverride
    }));
}
